import {
  SET_FIXED_ASSETS,
  SET_FIXED_ASSET_ACTION_LOADING,
  SET_FIXED_ASSET_DETAIL,
  SET_FIXED_ASSET_ERROR,
  SET_FIXED_ASSET_LOADING,
} from "../../actions/fixedAssetAction";

const initialState = { data: null, detail: null, loading: false, actionLoading: false, error: null };

const fixedAssetReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIXED_ASSETS:
      return { ...state, data: action.data, error: null };
    case SET_FIXED_ASSET_DETAIL:
      return { ...state, detail: action.data, error: null };
    case SET_FIXED_ASSET_LOADING:
      return { ...state, loading: action.status };
    case SET_FIXED_ASSET_ACTION_LOADING:
      return { ...state, actionLoading: action.status };
    case SET_FIXED_ASSET_ERROR:
      return { ...state, error: action.error, loading: false, actionLoading: false };
    default:
      return state;
  }
};

export default fixedAssetReducer;
